import React from "react";
import "@/App.css";
import { BrowserRouter, Routes, Route, useLocation } from "react-router-dom";
import { AnimatePresence, motion } from "framer-motion";
import { Toaster } from "@/components/ui/sonner";
import { LanguageProvider } from "@/i18n/LanguageContext";
import { WalletUIProvider } from "@/components/Wallet";
import { ScreenEffects } from "@/components/Effects";
import BootSequence from "@/components/BootSequence";
import Navbar from "@/components/Navbar";
import Footer from "@/components/Footer";
import Home from "@/pages/Home";
import TerminalPage from "@/pages/TerminalPage";
import Lore from "@/pages/Lore";
import Agent from "@/pages/Agent";
import Economy from "@/pages/Economy";
import Roadmap from "@/pages/Roadmap";
import Token from "@/pages/Token";
import Connect from "@/pages/Connect";

function Page({ children }) {
  return (
    <motion.div
      initial={{ opacity: 0, y: 16, filter: "brightness(1.5)" }}
      animate={{ opacity: 1, y: 0, filter: "brightness(1)" }}
      exit={{ opacity: 0, y: -10, transition: { duration: 0.18 } }}
      transition={{ duration: 0.4, ease: "easeOut" }}
    >
      {children}
    </motion.div>
  );
}

function AnimatedRoutes() {
  const location = useLocation();
  return (
    <AnimatePresence mode="wait">
      <Routes location={location} key={location.pathname}>
        <Route path="/" element={<Page><Home /></Page>} />
        <Route path="/terminal" element={<Page><TerminalPage /></Page>} />
        <Route path="/lore" element={<Page><Lore /></Page>} />
        <Route path="/agent" element={<Page><Agent /></Page>} />
        <Route path="/economy" element={<Page><Economy /></Page>} />
        <Route path="/roadmap" element={<Page><Roadmap /></Page>} />
        <Route path="/token" element={<Page><Token /></Page>} />
        <Route path="/connect" element={<Page><Connect /></Page>} />
        <Route path="*" element={<Page><Home /></Page>} />
      </Routes>
    </AnimatePresence>
  );
}

function App() {
  return (
    <BrowserRouter>
      <LanguageProvider>
        <WalletUIProvider>
          <div className="App relative flex min-h-screen flex-col bg-[#020611] text-mizu-silver">
            <ScreenEffects />
            <BootSequence />
            <Navbar />
            <main className="relative flex-1">
              <AnimatedRoutes />
            </main>
            <Footer />
          </div>
          <Toaster
            theme="dark"
            position="bottom-right"
            toastOptions={{
              style: {
                background: "#050A14",
                border: "1px solid rgba(0,240,255,0.25)",
                color: "#E2E8F0",
                fontFamily: "'JetBrains Mono', monospace",
                borderRadius: "2px",
              },
            }}
          />
        </WalletUIProvider>
      </LanguageProvider>
    </BrowserRouter>
  );
}

export default App;
